import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Eyebrow } from "./Eyebrow";
import { GridPattern } from "./GridPattern";

const FAQ = [
  {
    q: "Esse programa tem algum modelo de “indique e ganhe” ou MLM?",
    a: "Não. A remuneração é pelo volume divulgado pelo próprio parceiro aos seus clientes. Não existe estrutura de níveis, downline, recrutamento ou comissão por trazer outros parceiros. É divulgação direta de produto financeiro regulado.",
  },
  {
    q: "O produto é regulado?",
    a: "Sim. As debêntures são emitidas pela Companhia Securitizadora Allu Invest S.A. (CNPJ 62.446.127/0001-96), reguladas pela CVM e divulgadas pela Dexcap Investimentos (CNPJ 49.637.048/0001-02), plataforma autorizada sob a Resolução CVM nº 88/2022.",
  },
  {
    q: "Como funciona a remuneração do parceiro?",
    a: "A remuneração é competitiva e está acima da média do mercado para divulgação de produtos similares. O modelo exato (percentual, base de cálculo e recorrência) é apresentado na reunião 1:1, porque depende do volume, perfil do parceiro e estrutura da emissão.",
  },
  {
    q: "De onde vem o retorno do produto?",
    a: "Da operação real da Allu: compra de eletrônicos, aluguel em ciclos de assinatura para os mais de 60 mil clientes ativos, e revenda do ativo ao final. O lastro é o equipamento físico e o contrato de assinatura. Não é P2P, não é cripto, não é marketplace.",
  },
  {
    q: "Posso oferecer aos meus clientes mesmo sendo de outra plataforma?",
    a: "Em geral, sim — desde que não conflite com cláusulas de exclusividade que você tenha com outras instituições. Esse ponto é esclarecido no onboarding, antes de qualquer formalização.",
  },
  {
    q: "Qual perfil de cliente é adequado?",
    a: "Investidores que entendem crédito estruturado, aceitam o horizonte de tempo da emissão e têm perfil compatível com o risco. A análise de adequação (suitability) é feita dentro da plataforma regulada, conforme exigência da CVM. Os produtos não contam com garantia do FGC.",
  },
  {
    q: "E se o cliente quiser sair antes do vencimento?",
    a: "A liquidez segue as regras de cada emissão, informadas ao investidor antes da subscrição. Não prometemos liquidez diária — é crédito estruturado, e o cliente precisa entender isso antes de entrar.",
  },
  {
    q: "Que tipo de assessor vocês buscam?",
    a: "Profissionais com carteira própria de clientes e disposição para oferecer um produto que exige conversa de qualidade. Certificações ativas (CPA-20, CEA, CGA, CFP, AAI ou equivalentes) são valorizadas mas não bloqueantes.",
  },
];

export const ParceirosV2FAQ = () => {
  return (
    <section className="bg-white border-y border-zinc-200 py-16 sm:py-20 md:py-24 relative overflow-hidden">
      <GridPattern />
      <div className="container-narrow relative">
        <div>
          <div className="flex justify-center mb-4">
            <Eyebrow>Perguntas frequentes</Eyebrow>
          </div>
          <h2
            className="text-center font-extrabold leading-[1.1] tracking-tight text-[#323F4F] text-3xl sm:text-4xl md:text-5xl mt-6"
            style={{
              fontFamily:
                '"Plus Jakarta Sans", Inter, system-ui, sans-serif',
              letterSpacing: "-0.03em",
            }}
          >
            Dúvidas comuns antes de se candidatar.
          </h2>
        </div>

        <div className="mt-12 sm:mt-14">
          <Accordion
            type="single"
            collapsible
            defaultValue="item-0"
            className="space-y-3"
          >
            {FAQ.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="bg-[#F8F8F7] border border-zinc-200 rounded-2xl px-5 sm:px-7 hover:border-zinc-300 transition-colors data-[state=open]:border-zinc-300"
              >
                <AccordionTrigger
                  className="text-left text-[#323F4F] hover:no-underline py-5 text-sm sm:text-base font-extrabold"
                  style={{
                    fontFamily:
                      '"Plus Jakarta Sans", Inter, system-ui, sans-serif',
                    letterSpacing: "-0.03em",
                  }}
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-zinc-600 pb-5 text-sm sm:text-base leading-relaxed">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
